import React from 'react';
import { ChoiceSeq } from '../../../../utils/const';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const { questionNo, rightSectionProps } = state.rootReducer.testPageDetails;

	return {
		questionNo,
		rightSectionProps,
	};
};

const SetChoices = ({
	seqIncrement,
	identifier,
	choice,
	questionNo,
	rightSectionProps: { imageChoices, choices },
}) => {
	return (
		<li className={questionNo + '_' + ChoiceSeq[seqIncrement - 1]}>
			<input
				className="check-field"
				type="checkbox"
				id={`option-${ChoiceSeq[seqIncrement - 1]}`}
				name="MCQchoices[]"
				value={choices[choice]}
			/>
			<label htmlFor={`option-${ChoiceSeq[seqIncrement - 1]}`}>
				{!!imageChoices[choice] && imageChoices[choice] !== 'None' ? (
					<img src={imageChoices[choice]} alt="" />
				) : (
					choices[choice]
				)}
			</label>
		</li>
	);
};

export default connect(mapStateToProps)(SetChoices);
